import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Text, Badge, Stack, Tooltip } from '@ecoinvent/ui';

import ProcessTypeIcon, { getProcessTypeBadgeStyle } from 'components/UI/ProcessTypeIcon';
import TooltipBody from 'components/UI/TooltipBody';
import TooltipHeader from 'components/UI/TooltipHeader';
import { FlowDetailSuppliers as FlowDetailSupplier } from 'hooks/data/datasets/V4/flows/types';
import { formatNumericalValue } from 'utilities/numbers';

import { supplierTypeToTooltipLabel } from '../utils/constants';

type Props = {
  suppliers: FlowDetailSupplier[];
};

const SuppliersTable = ({ suppliers }: Props) => {
  const headers: (keyof FlowDetailSupplier)[] = ['type', 'name', 'geography', 'amount', 'unit'];

  return (
    <TableContainer>
      <Table variant="simple">
        <Thead>
          <Tr>
            {headers.map((header) => (
              <Th key={header}>{header}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {suppliers.map((supplier) => (
            <Tr key={supplier.id}>
              {headers.map((header) => (
                <Td key={header} textAlign="left">
                  {(() => {
                    if (header === 'type') {
                      const value = supplier[header];
                      const badgeStyle = getProcessTypeBadgeStyle(value);
                      const description = supplierTypeToTooltipLabel[value];

                      return (
                        <Tooltip
                          hasArrow
                          placement="top-start"
                          p={2}
                          label={
                            <Stack spacing={0}>
                              <TooltipHeader>{value}</TooltipHeader>
                              {description && <TooltipBody>{description}</TooltipBody>}
                            </Stack>
                          }
                        >
                          <Badge
                            bg={badgeStyle.bg}
                            color={badgeStyle.iconColor}
                            _dark={{ bg: badgeStyle.bg, color: badgeStyle.iconColor }}
                            borderRadius="base"
                            display="flex"
                            minWidth="24px"
                            maxWidth="24px"
                            height="24px"
                            flexShrink={0}
                            p={0}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <ProcessTypeIcon
                              icon={badgeStyle.icon}
                              subIcon={badgeStyle.subIcon}
                              boxSize="1em"
                              subBoxSize="0.5em"
                              subOffset="-1px"
                            />
                          </Badge>
                        </Tooltip>
                      );
                    }

                    if (header === 'amount') {
                      return <Text>{formatNumericalValue(supplier[header])}</Text>;
                    }

                    return <Text>{supplier[header] || ''}</Text>;
                  })()}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default SuppliersTable;
